import {
  ApiEventSearchResult,
  ApiExhibitorSearchResult,
  ApiPostSearchResult,
  ApiProductSearchResult,
  ApiSearchResult,
} from './search-api-response.models';

import { SearchStringFilter } from '../model/search-filter';
import {
  DateFilter,
  DateFilterType,
  DateFilterValue,
  StringFilter,
} from '../state/option-ids-visible/search-filter-options.models';
import {
  EventSearchResult,
  ExhibitorSearchResult,
  PostSearchResult,
  ProductSearchResult,
  SearchResult,
} from '../state/search-results/data-access-search.models';

export function mapApiResultsToFrontend(results: ApiSearchResult[]): SearchResult[] {
  return results.map((result) => mapApiResultToFrontend(result)).filter(Boolean);
}

export function mapApiResultToFrontend(result: ApiSearchResult): SearchResult {
  switch (result.type) {
    case 'EVENT':
      return mapEventApiResultToFrontend(result);
    case 'PRODUCT':
      return mapProductApiResultToFrontend(result);
    case 'EXHIBITOR':
      return mapExhibitorApiResultToFrontend(result);
    case 'POST':
      return mapPostApiResultToFrontend(result);
  }
}

function mapEventApiResultToFrontend(result: ApiEventSearchResult): EventSearchResult {
  return {
    type: result.type,
    ...result.event,
    starts_at: new Date(result.event.starts_at),
    ends_at: new Date(result.event.ends_at),
    published_at: new Date(result.event.published_at),
  };
}

function mapProductApiResultToFrontend(result: ApiProductSearchResult): ProductSearchResult {
  return {
    type: result.type,
    ...result.product,
    exhibitor_address: result.product.exhibitor?.address,
    exhibitor_id: result.product.exhibitor?.id,
    exhibitor_name: result.product.exhibitor?.name,
    published_at: new Date(result.product.published_at),
  };
}

function mapExhibitorApiResultToFrontend(result: ApiExhibitorSearchResult): ExhibitorSearchResult {
  return {
    type: result.type,
    ...result.exhibitor,
    published_at: new Date(result.exhibitor.published_at),
  };
}

function mapPostApiResultToFrontend(result: ApiPostSearchResult): PostSearchResult {
  return {
    type: result.type,
    ...result.post,
    exhibitor_id: result.post.exhibitor?.id,
    exhibitor_name: result.post.exhibitor?.name,
    published_at: new Date(result.post.published_at),
  };
}

export function resolveFilterParam(paramValue: string): SearchStringFilter[] {
  const dataAccessStringFilter = JSON.parse(paramValue) as StringFilter;
  const searchStringFilters: SearchStringFilter[] = [];

  for (const [name, filters] of Object.entries(dataAccessStringFilter)) {
    if (filters && filters.length > 0) {
      searchStringFilters.push({ name, filters });
    }
  }

  return searchStringFilters;
}

function mapStringToDateFilter(dateFilterString: string) {
  return JSON.parse(dateFilterString) as unknown as DateFilter;
}

export function resolveDateFilterParam(paramValue: string, timezone: string): DateFilterValue[] {
  const urlDateFilter = mapStringToDateFilter(paramValue);

  let lowerUTCTimestamp = undefined;
  let upperUTCTimestamp = undefined;
  const offset = parseInt(timezone.substring(1, 3)) * 60 * 60 + parseInt(timezone.substring(3, 5)) * 60;

  if (urlDateFilter.lower) {
    lowerUTCTimestamp = new Date(urlDateFilter.lower * 1000);
    lowerUTCTimestamp = lowerUTCTimestamp.getTime() / 1000 + lowerUTCTimestamp.getTimezoneOffset() * 60;
    lowerUTCTimestamp = lowerUTCTimestamp - offset;
  }

  if (urlDateFilter.upper) {
    upperUTCTimestamp = new Date(urlDateFilter.upper * 1000);
    upperUTCTimestamp = upperUTCTimestamp.getTime() / 1000 + upperUTCTimestamp.getTimezoneOffset() * 60;
    upperUTCTimestamp = upperUTCTimestamp - offset;
  }

  return [{ name: DateFilterType.startsAt, filters: [{ lower: lowerUTCTimestamp, upper: upperUTCTimestamp }] }];
}

export function toStringFilter(searchStringFilters: SearchStringFilter[]): StringFilter {
  const stringFilter: StringFilter = {};
  for (const { name, filters } of searchStringFilters) {
    stringFilter[name] = filters;
  }
  return stringFilter;
}
